(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["minty-cookie-banner"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = () => {
      const config = document.getElementById('minty-cookie-copy');
      if (!config || config.dataset.bound === 'true') return;
      let copy;
      try {
        copy = JSON.parse(config.textContent);
      } catch {
        return;
      }
      config.dataset.bound = 'true';
      const roots = '#shopify-pc__banner, #shopify-pc__prefs__dialog';
      const setText = (element, value) => {
        if (element && element.textContent !== value) element.textContent = value;
      };
      const orderDecisionButtons = (root) => {
        const accept = root.querySelector('#shopify-pc__banner__btn-accept, #shopify-pc__prefs__header-accept');
        const decline = root.querySelector('#shopify-pc__banner__btn-decline, #shopify-pc__prefs__header-decline');
        if (accept && decline && accept.parentElement === decline.parentElement && accept.previousElementSibling !== decline) {
          accept.before(decline);
        }
      };
      const updateCopy = () => {
        const banner = document.getElementById('shopify-pc__banner');
        if (banner) {
          orderDecisionButtons(banner);
          setText(banner.querySelector('#shopify-pc__banner__body-title'), copy.title);
          const paragraph = banner.querySelector('.shopify-pc__banner__body p');
          if (paragraph) {
            const link = paragraph.querySelector('a') || document.createElement('a');
            setText(link, copy.policy_label);
            const url = copy.policy_url || link.getAttribute('href');
            if (url && link.getAttribute('href') !== url) link.setAttribute('href', url);
            if (paragraph.textContent !== `${copy.description} ${copy.policy_label}` || !paragraph.contains(link)) {
              paragraph.replaceChildren(document.createTextNode(`${copy.description} `), link);
            }
          }
        }
        const preferences = document.getElementById('shopify-pc__prefs__dialog');
        if (preferences) {
          orderDecisionButtons(preferences);
          setText(preferences.querySelector('#shopify-pc__prefs__header-title'), copy.preferences_title);
          setText(preferences.querySelector('.shopify-pc__prefs__intro-main h3'), copy.intro_title);
          setText(preferences.querySelector('.shopify-pc__prefs__intro-main p'), copy.intro);
          const close = preferences.querySelector('#shopify-pc__prefs__header-close');
          if (close && close.getAttribute('aria-label') !== copy.close) close.setAttribute('aria-label', copy.close);
        }
      };
      const observer = new MutationObserver((mutations) => {
        const relevant = mutations.some((mutation) => {
          const target = mutation.target.nodeType === Node.ELEMENT_NODE ? mutation.target : mutation.target.parentElement;
          if (target?.closest(roots)) return true;
          return Array.from(mutation.addedNodes).some((node) =>
            node.nodeType === Node.ELEMENT_NODE && (node.matches(roots) || node.querySelector(roots))
          );
        });
        if (relevant) updateCopy();
      });
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
      updateCopy();
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["minty-psa-selection"] && !Shopify.designMode) return;
  try {
    (() => {
  function setup(root) {
    if (root.dataset.psaReady) return;
    root.dataset.psaReady = 'true';
    const track = root.querySelector('.psa-selection__track');
    const previous = root.querySelector('[data-psa-step="-1"]');
    const next = root.querySelector('[data-psa-step="1"]');
    const lines = root.querySelectorAll('.psa-selection__line');
    let lastWidth = -1;
    let frame = 0;
    function fitTitles() {
      lines.forEach(line => { line.style.fontSize = ''; });
      const sizes = Array.from(lines, line => {
        const available = line.clientWidth;
        const natural = line.firstElementChild.getBoundingClientRect().width;
        const base = parseFloat(getComputedStyle(line).fontSize);
        return available > 0 && natural > available ? base * (available - 2) / natural : base;
      });
      lines.forEach((line, index) => { line.style.fontSize = sizes[index] + 'px'; });
    }
    function scheduleFit() {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        fitTitles();
        updateControls();
      });
    }
    function updateControls() {
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }
    root.querySelectorAll('[data-psa-step]').forEach(button => {
      button.addEventListener('click', () => {
        const card = track.querySelector('.psa-selection__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const direction = Number(button.dataset.psaStep);
        track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      });
    });
    track.addEventListener('scroll', updateControls, {passive:true});
    new ResizeObserver(entries => {
      const width = entries[0].contentRect.width;
      if (Math.abs(width - lastWidth) < 1) return;
      lastWidth = width;
      scheduleFit();
    }).observe(track);
    document.fonts.ready.then(scheduleFit);
    scheduleFit();
    updateControls();
  }
  function initialize() {document.querySelectorAll('[data-psa-selection]').forEach(setup);}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["restock-alert"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('minty-restock')) {
    customElements.define('minty-restock', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const dialog = this.querySelector('dialog');
        const trigger = this.querySelector('[data-restock-open]');
        const container = this.querySelector('[data-restock-forms]');
        const loading = this.querySelector('[data-restock-loading]');
        const error = this.querySelector('[data-restock-error]');
        let timeout;
        let shadow;
        let ready = false;
        const focusEmail = () => {
          if (dialog.open) shadow?.querySelector('input[type="email"]')?.focus({ preventScroll: true });
        };
        const markReady = () => {
          if (ready || !shadow?.querySelector('form')) return;
          ready = true;
          clearTimeout(timeout);
          loading.hidden = true;
          error.hidden = true;
          focusEmail();
        };
        const observeForm = () => {
          const root = container.querySelector('shopify-forms-embed')?.shadowRoot;
          if (!root || root === shadow) return;
          shadow = root;
          this.formObserver = new MutationObserver(markReady);
          this.formObserver.observe(shadow, { childList: true, subtree: true });
          markReady();
        };
        this.containerObserver = new MutationObserver(observeForm);
        this.containerObserver.observe(container, { childList: true, subtree: true });
        observeForm();
        const loadForm = () => {
          if (ready) return;
          if (!timeout) timeout = setTimeout(() => {
            if (!ready) { loading.hidden = true; error.hidden = false; }
          }, 20000);
          // The installed Forms app embed supplies and updates its native renderer.
          // Keep submission, validation and the confirmation screen inside Forms.
          observeForm();
        };
        trigger.addEventListener('click', () => {
          if (!dialog.open) dialog.showModal();
          loadForm();
          focusEmail();
        });
        this.querySelector('[data-restock-reload]').addEventListener('click', () => window.location.reload());
        this.querySelectorAll('[data-restock-close]').forEach(button => {
          button.addEventListener('click', () => dialog.close());
        });
        let backdropStart = false;
        dialog.addEventListener('pointerdown', event => { backdropStart = event.target === dialog; });
        dialog.addEventListener('click', event => {
          if (backdropStart && event.target === dialog) dialog.close();
          backdropStart = false;
        });
        dialog.addEventListener('close', () => trigger.focus({ preventScroll: true }));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
